/**
 * Корпоративные сезоны (BLUEPRINT Stage 14, задача 4): компания покупает места счётом вне
 * системы, сотрудники входят по промокоду и попадают в приоритетный пул компании.
 */

export const CORPORATE = {
  /** Длина промокода, который генерирует админка */
  promoLength: 8,
  /** Алфавит промокода: без похожих символов (0/O, 1/I) */
  promoAlphabet: 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789',
  /** Насколько поднимается `PoolApplication.priority` у сотрудника компании */
  poolPriorityBonus: 2,
  /** Максимальная скидка сотруднику, % */
  maxDiscountPct: 50,
  /** Сколько мест максимум можно записать за компанией в одном счёте */
  maxSeats: 500,
} as const;

export type CorporateConstants = typeof CORPORATE;

/** Нормализует введённый промокод: верхний регистр без пробелов и дефисов. */
export function normalizePromoCode(raw: string): string {
  return raw.trim().toUpperCase().replace(/[\s-]/gu, '');
}
